import React, { useMemo } from 'react';

import usePage from '@dashboard/hooks/usePage';
import { PaymentsSubscriptionsList } from '@dashboard/scenes/PaymentsSubscriptions';

const DEFAULT_SORT = { createdAt: '-1' };

function RecentSubscriptions() {
  const { page } = usePage();

  const filter = useMemo(
    () => ({
      page: page._id,
      livemode: true,
    }),
    [page._id],
  );

  return (
    <div className="overflow-auto mb-20">
      <PaymentsSubscriptionsList
        sort={DEFAULT_SORT}
        filter={filter}
        options={{
          hidePaymentLink: true,
          hidePageType: true,
        }}
        infinite={false}
      />
    </div>
  );
}

export default RecentSubscriptions;
